/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-private-classes */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "empty", "error", "isValidating", "onSuccess", "pristine", "trimInputValue", "validateDefaultValue", "validateInput", "validationMessage", "validationOpts", "validator"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UIValidator from '../UIValidator';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { defaultProps, propTypes } from './UIValidatedFormControlPropsInterface';
import messageDefaults from '../constants/messageDefaults';
import WrappedChildInput from '../utils/components/WrappedChildInput';
import { jsx as _jsx } from "react/jsx-runtime";
class UIValidatedFormControl extends Component {
  constructor(...args) {
    super(...args);
    this.getMessage = () => {
      const {
        validationMessage,
        error,
        empty,
        isValidating,
        pristine
      } = this.props;
      if (pristine) {
        return '';
      }
      if (isValidating) {
        return validationMessage.validating;
      }
      if (empty) {
        return validationMessage.empty;
      }
      if (error) {
        return validationMessage.error;
      }
      return validationMessage.success;
    };
  }
  componentDidMount() {
    const {
      value,
      validateInput
    } = this.props;
    if (value && typeof value === 'string') {
      const evt = {
        target: {
          value
        }
      };
      validateInput(evt);
    }
  }
  componentDidUpdate(previousProps) {
    // If the value prop is provided, revalidate when it changes to allow for external control of input value
    const {
      value,
      validateInput
    } = this.props;
    const {
      value: oldValue
    } = previousProps;
    if (value && typeof value === 'string' && value !== oldValue) {
      const evt = {
        target: {
          value
        }
      };
      validateInput(evt);
    }
  }
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        error,
        trimInputValue,
        validateDefaultValue,
        validateInput
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(UIFormControl, Object.assign({}, rest, {
      className: classNames('private-validated-form-control', className),
      error: error,
      validationMessage: this.getMessage(),
      children: /*#__PURE__*/_jsx(WrappedChildInput, {
        onChange: validateInput,
        trimInputValue: trimInputValue,
        validateDefaultValue: validateDefaultValue,
        children: children
      })
    }));
  }
}
UIValidatedFormControl.propTypes = Object.assign({}, propTypes, {
  validateInput: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  empty: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  value: PropTypes.string
});
UIValidatedFormControl.defaultProps = Object.assign({}, defaultProps, {
  validationMessage: messageDefaults,
  validateDefaultValue: false
});
export default UIValidator(UIValidatedFormControl);